import { TimeRange } from '@mi-front/core';

/**
 * Converts a timestamp into a 0..100 percentage of the given time range.
 * Used to position the shared playhead over the focus-tracks stack.
 */
export function tsToPercent(ts: number, range: TimeRange<number>): number {
  const span = range.to - range.from;

  if (span <= 0) {
    return 0;
  }

  return ((ts - range.from) / span) * 100;
}
